'use client';
import { Spacer as SharedSpacer } from '@launchstore/shared-puck';
import type { SpacerProps } from '@launchstore/shared-puck';
export const Spacer: any = SharedSpacer;
export type { SpacerProps };
export default Spacer;
